import { ModuleLayout } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { TransactionViewProvider } from '@features/transactions/contexts/transactionViewContext'
import { TransactionViewTrackingContext } from '@features/transactions/enums/transactionViewTrackingContext'

import { TransactionsListEmpty } from '../TransactionsListEmpty'
import { TransactionsSideActions } from './elements/TransactionsSideActions'
import { TransactionsTable } from './elements/TransactionsTable'
import { TransactionsTableActions } from './elements/TransactionsTableActions'
import { useIsTransactionsListEmpty } from './hooks/useIsTransactionsListEmpty'

export const TransactionsList = (): ReactElement => {
  const { t } = useTranslation()
  const isTransactionsListEmpty = useIsTransactionsListEmpty()

  if (isTransactionsListEmpty) {
    return <TransactionsListEmpty />
  }

  return (
    <ModuleLayout sideActions={<TransactionsSideActions />} title={t('transactions')}>
      <TransactionViewProvider trackingContext={TransactionViewTrackingContext.Transactions}>
        <TransactionsTableActions />
        <TransactionsTable />
      </TransactionViewProvider>
    </ModuleLayout>
  )
}
